import React from 'react'
import {makeStyles} from '@material-ui/core'
import { HashLink as Link } from 'react-router-hash-link';
import Personimage from '../images/me3.jpg'
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
const useStyles = makeStyles((theme)=>({
    footer:{
       
        borderTop:'1px solid #ccc',
        position:'relative'
    },
    moveup:{
        position:'absolute',
  left:'50%',
  top:'-25px',
  height:'45px',
  width:'45px',
  borderRadius:'50%',
  zIndex:'50',
  backgroundColor:'#F9FAFB',
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  cursor:'pointer',
  boxShadow:'0 3px 6px 2px rgba(0,0,0,0.1)',
color:'teal'
    },
    footerContent:{
display: 'flex',
alignItems:'center',
margin:'25px 0'
    },
    image:{
        height:'40px',
        width:'40px',
      
        borderRadius:'50%',
        backgroundImage:`url(${Personimage})`,
        backgroundPosition:'center',
        backgroundSize:'cover',
    }
}));
function Footer() {
const classes = useStyles();
    return (
        <div className={classes.footer}>
        <Link
smooth to="/#home"
style={{textDecoration:'none'}}>   
 <div className={classes.moveup}><ExpandLessIcon style={{fontSize:'40px'}}/></div> 

</Link>
            <div className={classes.footerContent}>
                <div className={classes.image}>

                </div>
                <div style={{marginLeft:'10px'}}>Anjan Poudel</div>
            </div>
        </div>
    )
}

export default Footer
